import r from "./index408.js";
import { resolveComponent as c, createElementBlock as t, openBlock as s, createElementVNode as n, createCommentVNode as a, normalizeClass as l, createVNode as m } from "vue";
/* empty css         */
import i from "./index231.js";
const p = ["data-component"], d = { class: "flex items-center justify-center screen-l:h-full screen-l:w-auto screen-l:justify-start" }, u = {
  key: 0,
  class: "ml-8"
};
function _(e, f, h, v, x, k) {
  const o = c("ms-menu");
  return s(), t("div", {
    class: "flex items-center px-16 cursor-pointer screen-m:px-24 screen-l:px-0 screen-l:h-38 screen-l:max-h-38 screen-l:min-h-38",
    "data-component": e.$options.name,
    "data-test-id": "button"
  }, [
    n("div", d, [
      n("div", {
        class: l(["relative inline-block", {
          dot: e.showDot
        }])
      }, [
        m(o, { class: "w-24 h-24" })
      ], 2),
      e.isScreenL ? (s(), t("span", u, "Rubrik auswählen")) : a("", !0)
    ])
  ], 8, p);
}
const y = /* @__PURE__ */ i(r, [["render", _], ["__scopeId", "data-v-342a9404"]]);
export {
  y as default
};
